import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import DialogContent from "@material-ui/core/DialogContent";
import { useDispatch } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { DialogActions, Grid } from "@material-ui/core";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import { getAxFitting, getColorFitting, getDirectionFitting, updateStuffFitting } from "Stores/actions";
import showNotify from "Helpers/Notify";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTranslation } from 'react-i18next';
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import * as Icons from "react-bootstrap-icons";

function EditStuff({ row }) {
    const { direction } = useTheme();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [formValid, setFormValid] = useState({});
    const [loading, setLoading] = useState(false);
    const [checkValid, setCheckValid] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [controls, setControls] = useSetState({
        name: {
            type: "text",
            value: "",
            validation: {
                required: true,
            },
        },
        standardCode: {
            type: "text",
            value: "",
            validation: {
                required: true,
            },
        },
        stuffAx: {
            type: "select",
            selectItems: [],
            value: "",
            validation: null,
        },
        stuffSide: {
            type: "select",
            selectItems: [],
            value: "",
            validation: null,
        },
        stuffColor: {
            type: "select",
            selectItems: [],
            value: "",
            validation: null,
        },
    });

    const handleDialog = () => {
        setOpenDialog(!openDialog);
    }

    const onEnter = async () => {
        onClear();
        setLoading(true);
        const axfitting = await dispatch(getAxFitting());
        const directionFitting = await dispatch(getDirectionFitting());
        const colorFitting = await dispatch(getColorFitting());
        setControls({ stuffAx: { selectItems: axfitting, value: axfitting.find(i => i.Id === row.Ax) }});
        setControls({ stuffSide: { selectItems: directionFitting, value: directionFitting.find(i => i.Id === row.IdSdirection ) }});
        setControls({ stuffColor: { selectItems: colorFitting, value: colorFitting.find(i => i.Id === row.IdColorFitting) }});
        setLoading(false);
    }
   
    const onClear = () => {
        setCheckValid(false);
        setFormValid({ name: true, standardCode: true });
        setControls({ name: { value: row.Name } });
        setControls({ standardCode: { value: row.Code } });
    }

    const setValue = async (name, value, validation) => {
        setControls({ [name]: { value: value } });
        setFormValid((prev) => ({ ...prev, [name]: validation }));
    }

    const autoCompleteHandler = async (e, value) => {
        const controlName = e.target.id.split("-")[0];
        setControls({ [controlName]: { value: value } });
    };

    const onFinish = async (e) => {
        e.preventDefault();
        if (!R.isEmpty(formValid) && Object.values(formValid).every((item) => item === true)) {
            const { name, standardCode, stuffAx, stuffSide, stuffColor } = controls;
            try {
                setLoading(true);
                const data = {
                    KeyGroup: read("groupKey"),
                    KeyUser: read("userKey"),
                    id: row.Id,
                    idBrandFitting: row.idBrandFitting,
                    idSdirection: stuffSide.value.value,
                    idSlevelSecurity: 0,
                    ax: stuffAx.value.value,
                    idColorFitting: stuffColor.value.value,
                    name: name.value,
                    code: standardCode.value
                };
                await dispatch(updateStuffFitting(data));
                setLoading(false);
            } catch (e) {
                console.log('edit stuff', e);
                setLoading(false);
            }
        } else {
            setCheckValid(true);
            showNotify({
                text: t('correctFormDataRequired'),
                customClass: "error",
            });
        }
    }

    return (
        <>
            <BackDropLoading loading={loading} />
            <ActionFormatter
                title={<Translator id="virayesh" />}
                icon={<Icons.Pencil size={17} />}
                className="warning-fill"
                onClick={handleDialog}
                disabled={row.IsG && read("StypeU") !== "1"}
            />
            <Dialog
                dir={direction}
                open={openDialog}
                onClose={handleDialog}
                TransitionProps={{
                onEnter: onEnter,
                }}
                fullWidth
                maxWidth="sm"
            >
                <form onSubmit={onFinish}>
                    <div className="dialogHeader">
                        <Translator id={"editStuff"}/>
                    </div>
                    <DialogContent>
                        <Grid container spacing={2}>
                            {
                                Object.keys(controls).map((key, index) => {
                                    return (
                                        <>
                                            {
                                                controls[key].type === "select" &&
                                                <Grid item key={key + index} sm={4} xs={12}>
                                                    <MuiAutoComplete
                                                        loading={loading}
                                                        options={controls[key].selectItems}
                                                        label={<Translator id={key} />}
                                                        value={controls[key].value}
                                                        id={key}
                                                        onChange={autoCompleteHandler}
                                                    />
                                                </Grid>
                                            }
                                            {
                                                controls[key].type === "text" &&
                                                <Grid item key={key + index} sm={6} xs={12}>
                                                    <Input
                                                        setValue={setValue.bind(this)}
                                                        name={key}
                                                        placeholder={t(key)}
                                                        validation={controls[key].validation}
                                                        label={<Translator id={key} />}
                                                        type="text"
                                                        checkValid={checkValid}
                                                        value={controls[key].value}
                                                    />
                                                </Grid>
                                            }
                                        </>
                                    );
                                })
                            }
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <MuiButton
                            color="primary"
                            type="submit"
                            title={<Translator id="button_save" />}
                            onClick={onFinish}
                        />
                        <MuiButton
                            onClick={handleDialog}
                            title={<Translator id="enseraf" />}
                        />
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}

export default EditStuff;